import { FC, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Loader from '../components/common/loader'
import AccountFooter from '../containers/AccountFooter'
import AccountHeader from '../containers/AccountHeader'
import { PARENT_ROUTES, ROUTES } from '../utils/constants/enum'
import PageNotFound from './pages/404'
import routes from './routes'

interface IAccountsRouterProps {
    onLoad: () => void
}

const AccountsRouter: FC<IAccountsRouterProps> = ({ onLoad }) => {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (
            location.pathname === `${ROUTES.ACCOUNTS}` ||
            location.pathname === `${ROUTES.ACCOUNTS}/`
        ) {
            navigate(`${ROUTES.SIGNIN}`)
        }
    }, [navigate])

    useEffect(() => {
        onLoad()
    }, [location])

    if (!location.pathname.includes(`${ROUTES.ACCOUNTS}`)) {
        return null
    }
    if (
        location.pathname === `${ROUTES.ACCOUNTS}` ||
        location.pathname === `${ROUTES.ACCOUNTS}/`
    ) {
        return null
    }
    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                {routes
                    .filter(
                        (route) => route.childOf === PARENT_ROUTES.ONBOARDING
                    )
                    .map((route) => {
                        return (
                            route.component && (
                                <Route
                                    key={`route-${route.name}`}
                                    path={route.path}
                                    element={
                                        <>
                                            <AccountHeader status={false} />
                                            <route.component />
                                            <AccountFooter status={false} />
                                        </>
                                    }
                                />
                            )
                        )
                    })}
                <Route key="404" path="*" element={<PageNotFound />} />
            </Routes>
        </Suspense>
    )
}

export default AccountsRouter
